var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M21.41 14.077l-3.361-.516-1.507-3.195a.628.628 0 0 0-.57-.366c-.238 0-.46.15-.57.366l-1.507 3.195-3.361.516a.626.626 0 0 0-.507.45.719.719 0 0 0 .158.682l2.442 2.496-.57 3.512c-.048.25.063.5.253.65.19.15.46.166.666.05l3.012-1.665 3.013 1.665c.095.05.19.083.301.083.127 0 .27-.05.381-.133.19-.15.286-.4.254-.65l-.571-3.512 2.442-2.496a.682.682 0 0 0 .158-.683c-.128-.25-.318-.416-.556-.449z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECDC17",
    fillRule: "evenodd",
    stroke: "#D7B300",
    strokeWidth: 0.5,
    d: "M11.376 4.325h-.004l-3.493-.537-.056-.12L6.317.473A.378.378 0 0 0 5.972.25a.406.406 0 0 0-.345.222L4.064 3.788l-.131.02-3.365.517a.376.376 0 0 0-.3.267.468.468 0 0 0 .096.442l2.53 2.587-.02.124-.572 3.52a.427.427 0 0 0 .163.405.358.358 0 0 0 .39.028l3.133-1.731.121.066 3.01 1.663a.378.378 0 0 0 .183.054.411.411 0 0 0 .226-.08.46.46 0 0 0 .162-.413l-.591-3.636.088-.09 2.44-2.495c.112-.117.151-.286.117-.395-.098-.191-.226-.297-.368-.316z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star-yellow.43e5af6fc5a5df9cd32cead640c8a3f1.svg";
export { ForwardRef as ReactComponent };